import React from "react";
import { MapPin, Phone, Mail, Clock, Navigation } from "lucide-react";
import { formatDistance } from "@/lib/geo";

const DealerCard = ({ dealer, distanceKm, compact = false, plain = false }) => (
    <div
        className={plain
            ? `h-full flex flex-col rounded-2xl border border-[#e8eaee] bg-white ${compact ? "p-4" : "p-4 sm:p-5"}`
            : `bike-card ${compact ? "p-4" : "p-5"}`}
        data-testid={`dealer-${dealer.id}`}
    >
        <div className="flex items-start justify-between gap-2">
            <h3 className={`font-display font-bold leading-tight ${compact ? "text-sm" : "text-base"}`}>{dealer.name}</h3>
            <span className="chip chip-brand text-[10px] shrink-0">{dealer.brand}</span>
        </div>
        {distanceKm != null && (
            <p className="text-xs font-semibold text-[#E31837] mt-2" data-testid={`dealer-distance-${dealer.id}`}>
                {formatDistance(distanceKm)}
            </p>
        )}
        <p className="text-sm text-[#4a4a52] mt-2 leading-relaxed flex gap-2">
            <MapPin size={14} className="flex-shrink-0 mt-0.5 text-[#7a7a84]" />
            <span className="min-w-0 break-words">{dealer.address}</span>
        </p>
        {!compact && (
            <>
                <p className="text-sm text-[#4a4a52] mt-2 flex items-center gap-2">
                    <Clock size={14} className="text-[#7a7a84]" /> {dealer.working_hours}
                </p>
                <p className="text-sm text-[#4a4a52] mt-1 flex items-center gap-2">
                    <Phone size={14} className="text-[#7a7a84]" /> {dealer.phone}
                </p>
                <p className="text-sm text-[#4a4a52] mt-1 flex items-center gap-2">
                    <Mail size={14} className="shrink-0 text-[#7a7a84]" />
                    <span className="min-w-0 break-all">{dealer.email}</span>
                </p>
            </>
        )}
        <div className={`flex gap-2 ${plain ? "mt-auto pt-4" : compact ? "mt-3" : "mt-4"}`}>
            <a
                href={`https://www.google.com/maps/dir/?api=1&destination=${dealer.lat},${dealer.lng}`}
                target="_blank"
                rel="noreferrer"
                className="btn btn-primary btn-sm flex-1 justify-center min-h-[44px]"
                data-testid={`dealer-directions-${dealer.id}`}
            >
                <Navigation size={14} /> Directions
            </a>
            <a
                href={`tel:${(dealer.phone || "").replace(/\s/g, "")}`}
                className="btn btn-white btn-sm flex-1 justify-center min-h-[44px]"
                data-testid={`dealer-call-${dealer.id}`}
            >
                <Phone size={14} /> Call
            </a>
        </div>
    </div>
);

export default DealerCard;
